import { useDispatch } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { useAppSelector } from 'src/hooks/useStore';
import { setLiveData } from 'src/store/slices/transaction.slice';

// Test / Live switch (SONIO brand: green dot = live, no looping animation)
export default function StandaloneToggleButton({
  collapsed,
}: {
  collapsed: boolean;
}) {
  const dispatch = useDispatch();
  const { liveData } = useAppSelector(state => state.sliceTransaction);
  const setMode = (live: boolean) => {
    if (live !== liveData) dispatch(setLiveData(live));
  };

  if (collapsed) {
    return (
      <Tooltip
        title={
          liveData ? 'Live mode · click for Test' : 'Test mode · click for Live'
        }
        placement="right"
      >
        <button
          type="button"
          onClick={() => setMode(!liveData)}
          className="flex w-full items-center justify-center rounded-[9px] bg-white py-2 shadow-[0_1px_3px_rgba(12,35,64,0.12)]"
        >
          <span
            className={`h-2.5 w-2.5 rounded-full ${
              liveData
                ? 'bg-[#6ECF89] shadow-[0_0_0_3px_rgba(110,207,137,0.25)]'
                : 'bg-[#00387D]'
            }`}
          />
        </button>
      </Tooltip>
    );
  }

  const option = (live: boolean, label: string) => {
    const on = liveData === live;
    return (
      <button
        type="button"
        onClick={() => setMode(live)}
        aria-pressed={on}
        className={`flex flex-1 items-center justify-center gap-2 rounded-[9px] py-[7px] text-[13.5px] font-semibold transition-colors ${
          on
            ? 'bg-white text-[#0C2340] shadow-[0_1px_3px_rgba(12,35,64,0.12)]'
            : 'text-[#5B6B80] hover:text-[#0C2340]'
        }`}
      >
        <span
          className={`h-[7px] w-[7px] rounded-full ${
            on
              ? live
                ? 'bg-[#6ECF89] shadow-[0_0_0_3px_rgba(110,207,137,0.25)]'
                : 'bg-[#00387D]'
              : 'bg-[#C3CCD8]'
          }`}
        />
        {label}
      </button>
    );
  };

  return (
    <div className="flex w-full">
      {option(false, 'Test')}
      {option(true, 'Live')}
    </div>
  );
}
